// useDeviceClass.js
import { useEffect } from 'react';
import { isIphoneX, isChrome, isIOSDevice, isEdge, isIE, hardCodeIsLowes, isFirefox } from '../../helpers/sqftHelper';

const useAddDeviceClass = () => {
  useEffect(() => {
    const classes = [];
    if (isIphoneX()) classes.push('sqft--iphoneX');
    if (isChrome()) classes.push('sqft--chrome');
    if (isIphoneX()) { classes.push('sqft--iphoneX'); }
    if (isChrome()) { classes.push('sqft--chrome'); }
    if (isIOSDevice()) { classes.push('sqft--ios'); }
    if (isEdge()) { classes.push('sqft--edge'); }
    if (isIE()) { classes.push('sqft--ie'); }
    if (hardCodeIsLowes()) { classes.push('sqft--lowes'); }
    if (isFirefox()) { classes.push('sqft--firefox'); }
    // Add more conditions here

    classes.forEach(cls => document.body.classList.add(cls));

    // Cleanup
    return () => {
      classes.forEach(cls => document.body.classList.remove(cls));
    };
  }, []);
};

export default useAddDeviceClass;
